import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import Cookiesimage from "@assets/images/CookiesImage.webp";
import modalBorder from "@assets/images/borders/modalBorder.webp";
import DownArrow from "@assets/images/down-arrow.svg";
import Cookies from "js-cookie";
import { loadGtag } from "@src/utils/loadGTag";
import useOnclickOutside from "react-cool-onclickoutside";

const CookieBanner: React.FC = () => {
  const cookiesModalRef = useRef<HTMLDivElement>(null);
  useOnclickOutside(
    () => {
      document.getElementById("cookie-modal")?.classList.add("form-shake");
    },
    { refs: [cookiesModalRef], ignoreClass: ["swal2-container"] }
  );
  const [visibleCookieText, setVisibleCookieText] = useState(false);
  const [analyticsCookieToggle, setAnalyticsCookieToggle] = useState(true);
  const [functionalityCookieToggle, setFunctionalityCookieToggle] =
    useState<boolean>(true);
  const [showCookieBanner, setShowCookieBanner] = useState<boolean>(
    Cookies.get("cookieBanner") ? false : true
  );

  const [cookieSettingModalOpen, setCookieSettingModalOpen] = useState(false);

  // useEffect(() => {
  //   const header = document.getElementById("header");
  //   const footer = document.getElementById("footer");

  //   if (cookieSettingModalOpen) {
  //     document.body.style.overflow = "hidden";
  //     if (header) {
  //       header.style.zIndex = "0";
  //     }
  //     if (footer) {
  //       footer.style.zIndex = "-1";
  //     }
  //   }

  //   return () => {
  //     if (header) {
  //       header.style.zIndex = "";
  //     }
  //     if (footer) {
  //       footer.style.zIndex = "";
  //     }
  //     document.body.style.overflow = "auto";
  //   };
  // }, [cookieSettingModalOpen]);

  const [scrollPosition, setScrollPosition] = useState(0);
  useLayoutEffect(() => {
    if (showCookieBanner || cookieSettingModalOpen) {
      const currentScroll = window.scrollY;
      setScrollPosition(currentScroll);
      document.body.style.top = `-${currentScroll}px`;
      document.body.classList.add("!fixed", "overflow-hidden", "w-full");
    } else {
      document.body.classList.remove("!fixed", "overflow-hidden", "w-full");
      document.body.style.top = "";
      window.scrollTo(0, scrollPosition);
    }

    return () => {
      document.body.classList.remove("!fixed", "overflow-hidden", "w-full");
      document.body.style.top = "";
    };
  }, [showCookieBanner, cookieSettingModalOpen]);

  return (
    <>
      {showCookieBanner && (
        <div className="fixed m-5 bottom-0 right-0 bg-[#2b3348db] border-[#59607d] rounded-3xl p-6 max-sm:p-3 backdrop-blur-lg border z-30 max-lg:left-0 max-lg:bottom-0 max-lg:m-4">
          <div className="flex items-center gap-5 max-md:flex-col">
            <div className="flex items-center gap-1">
              <img
                alt="cookie-image"
                src={Cookiesimage}
                className="w-14 h-14"
              />
              <span className="text-primary text-xl max-sm:text-lg">
                WE USE COOKIES TO PROVIDE YOU WITH THE BEST USER EXPERIENCE AND
                FOR PERFORMANCE ANALYTICS.
              </span>
            </div>
            <div className="flex items-center gap-3 max-md:w-full max-md:grid max-md:grid-cols-2">
              <button
                onClick={() => {
                  setVisibleCookieText(false);
                  setCookieSettingModalOpen(!cookieSettingModalOpen);
                }}
                className="bg-gradient-pink-blue rounded-xl max-sm:rounded p-[2px] max-sm:p-px duration-200 hover:opacity-60 w-auto max-md:w-full"
              >
                <span className="px-5 py-3 max-sm:px-2 max-sm:py-2 max-sm:text-sm max-sm:rounded block text-black text-xl rounded-xl bg-[#37426f] text-nowrap">
                  CHANGE SETTINGS
                </span>
              </button>
              <button
                className="px-12 max-sm:px-9 max-sm:py-2 max-sm:text-sm max-sm:rounded py-3 bg-gradient-pink-blue text-blue text-xl rounded-lg w-auto duration-200 hover:opacity-60 max-md:w-full"
                onClick={() => {
                  const options: Cookies.CookieAttributes = {};
                  options.expires = 14;
                  Cookies.set("cookieBanner", "true", options);
                  Cookies.set("rememberMe", "true", options);

                  loadGtag();
                  setShowCookieBanner(false);
                }}
                aria-label="Okay"
              >
                OKAY
              </button>
            </div>
          </div>
        </div>
      )}

      {cookieSettingModalOpen && (
        <div className="fixed size-full bg-[#00000080] top-0 left-0 grid place-items-center z-[999] overflow-auto">
          <div
            id="cookie-modal"
            className="max-w-2xl max-md:max-w-[95%] p-10 max-md:p-5 max-md:mx-auto w-full bg-gradient-to-b from-blue to-skyblue relative rounded-[5px_30px_40px_0px]"
            onAnimationEnd={() => {
              document
                .getElementById("cookie-modal")
                ?.classList.remove("form-shake");
            }}
          >
            <img
              src={modalBorder}
              className="absolute top-0 left-0 size-full z-[0]"
              alt=""
            />
            <div
              ref={cookiesModalRef}
              className="relative z-10 max-h-[80dvh] overflow-auto"
            >
              <div className="flex items-center justify-between gap-2 mb-6">
                <h1 className="text-primary text-3xl">Cookies Settings</h1>
                <button
                  onClick={() =>
                    setCookieSettingModalOpen(!cookieSettingModalOpen)
                  }
                  className="text-primary text-4xl ml-auto duration-150 hover:scale-95"
                  aria-label="Close"
                >
                  <i className="ri-close-circle-line"></i>
                </button>
              </div>
              <div className="flex items-center justify-between gap-2 mb-2 flex-wrap">
                <h1 className="text-primary text-2xl max-md:text-xl">
                  Strictly Necessary Cookies
                </h1>
                <div
                  className="text-primary-gradient text-xl flex items-center cursor-pointer"
                  onClick={() => {
                    setVisibleCookieText(!visibleCookieText);
                  }}
                >
                  Always active{" "}
                  <span>
                    <img
                      src={DownArrow}
                      className={`ml-2 w-5 ${
                        visibleCookieText && "rotate-180"
                      }`}
                    />
                  </span>
                </div>
              </div>
              {visibleCookieText && (
                <p className="text-white text-xl max-md:text-base py-2 mb-6">
                  Strictly necessary cookies are required for the website to
                  function properly. These cookies are used for services such as
                  payment processing. You may set your web browser to disable
                  these cookies, but parts of the website will not work.
                </p>
              )}
              <div className="bg-no-repeat bg-contain bg-center bg-[url('@assets/images/ContactBorder.png')] w-full h-6"></div>
              <div className="flex items-center justify-between">
                <h5 className="text-primary text-2xl max-md:text-xl">
                  Analytics Cookies
                </h5>
                <button
                  onClick={() =>
                    setAnalyticsCookieToggle(!analyticsCookieToggle)
                  }
                  className={`w-12 h-6 rounded-full bg-cover p-1 relative ${
                    analyticsCookieToggle ? "bg-secondary" : "bg-[#89D9EE]"
                  }`}
                >
                  <div
                    className={`w-4 h-4  rounded-full absolute top-1 z-10 ${
                      analyticsCookieToggle
                        ? "right-1 bg-[#FFBFF7]"
                        : "left-1 bg-blue"
                    }`}
                  ></div>
                </button>
              </div>
              <div className="flex items-center justify-between mt-3">
                <h5 className="text-primary text-2xl max-md:text-xl">
                  Functionality Cookies
                </h5>
                <button
                  onClick={() =>
                    setFunctionalityCookieToggle(!functionalityCookieToggle)
                  }
                  className={`w-12 h-6 rounded-full bg-cover p-1 relative ${
                    functionalityCookieToggle ? "bg-secondary" : "bg-[#89D9EE]"
                  }`}
                >
                  <div
                    className={`w-4 h-4  rounded-full absolute top-1 z-10 ${
                      functionalityCookieToggle
                        ? "right-1 bg-[#FFBFF7]"
                        : "left-1 bg-blue"
                    }`}
                  ></div>
                </button>
              </div>

              <div className="flex items-center gap-3 justify-end mt-5 max-sm:flex-col">
                <button
                  onClick={() => {
                    const options: Cookies.CookieAttributes = {};
                    options.expires = 14;
                    Cookies.set("cookieBanner", "false", options);
                    Cookies.set("rememberMe", "false", options);

                    setCookieSettingModalOpen(false);
                    setShowCookieBanner(false);
                  }}
                  className="shadow-md bg-blue rounded-2xl p-[2px] max-sm:w-full border-4 border-secondary"
                >
                  <span className="text-primary-gradient text-xl rounded-xl py-3 px-5 block">
                    Reject All
                  </span>
                </button>
                <button
                  className="shadow-md bg-gradient-to-r from-[#cb8bcf] via-[#825ef5] to-[#1ea0e8] rounded-xl p-[2px] max-sm:w-full hover:from-[#1ea0e8] hover:via-[#825ef5] hover:to-[#cb8bcf]"
                  onClick={() => {
                    if (analyticsCookieToggle) {
                      loadGtag();

                      const options: Cookies.CookieAttributes = {};
                      options.expires = 14;
                      Cookies.set("cookieBanner", "true", options);
                    } else {
                      const options: Cookies.CookieAttributes = {};
                      options.expires = 14;
                      Cookies.set("cookieBanner", "false", options);
                    }

                    const options: Cookies.CookieAttributes = {};
                    options.expires = 14;
                    Cookies.set(
                      "rememberMe",
                      functionalityCookieToggle.toString(),
                      options
                    );
                    setCookieSettingModalOpen(false);
                    setShowCookieBanner(false);
                  }}
                >
                  <span className="text-blue text-xl rounded-xl py-3 px-5 block">
                    Confirm My Choices
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
